//@ts-ignore
import Swiper, { Pagination, Thumbs, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Thumbs, Navigation, Autoplay ]);

export namespace HeroSlider {
	let setupSlider = () => {
        let heroSliders = document.querySelectorAll('.js-hero-slider');

        heroSliders.forEach(function(heroSlider, index) {

            // get our initial values
            let thumbSlider = heroSlider.nextElementSibling.querySelector('.js-gallery-thumbs');
            let heroSliderList = [];

            // add classes with indexes to handle multiple sliders
            thumbSlider.classList.add('js-gallery-thumbs-' + index);
			heroSlider.classList.add('hero-slider-' + index);
            heroSlider.setAttribute("id", 'slider-id' + index);

            // setup our thumbnail slider
            let heroThumbs = new Swiper ('.js-gallery-thumbs-' + index, {
                spaceBetween: 10,
                freeMode: true,
                watchSlidesProgress: true,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 1200px
                    1200: {
                        slidesPerView: 3,
                    }
                },
                pagination: {
                    el: ".thumb-pagination",
                    clickable: true
                },
            });

            // setup our hero slider w/ thumbnail reference
            let heroSliderSwiper = new Swiper('.hero-slider-' + index, {
                autoplay: {
                    delay: 5000
                },
				slidesPerView: 1,
				speed: 600,
				spaceBetween: 0,
                loop: true,
				centeredSlides: true,
				simulateTouch: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                thumbs: {
                    swiper: heroThumbs,
                }
			});

			heroSliderList.push(heroSliderSwiper);
			heroSliderSwiper.init();
        });
	}

	export const init = () => {
		setupSlider();
	}
}